import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquized: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquized"><Path d="M12 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 9L8.5 12L5.5 15" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 9L15.5 12L18.5 15" stroke="currentColor" strokeLinecap="square"/><Path d="M8 12H1.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22.5 12H16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquized;
